import { render, staticRenderFns } from "./BusinessSidebar.vue?vue&type=template&id=5b3d74aa&scoped=true"
import script from "./BusinessSidebar.vue?vue&type=script&lang=js"
export * from "./BusinessSidebar.vue?vue&type=script&lang=js"
import style0 from "./BusinessSidebar.vue?vue&type=style&index=0&id=5b3d74aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3d74aa",
  null
  
)

export default component.exports